/**
 * @mixin
 */
export default {
	data() {
		return {
			checked: this.value
		};
	},
	props: {
		labelText: {
			type: String,
			default: ''
		},
		value: {
			type: Boolean,
			default: false
		},
		checkboxValue: {
			type: [String, Number, Boolean],
			default: ''
		},
		onToggleChange: {
			type: Function,
			default: () => {}
		}
	},
	created() {
		this.checked = this.value;
	},
	watch: {
		value: {
			immediate: true,
			handler(val) {
				this.checked = val;
			}
		}
	},
	computed: {
		isChecked: {
			get: function() {
				return this.checked;
			},
			set: function(newValue) {
				this.checked = newValue;
			}
		}
	},
	methods: {
		onChange() {
			this.$emit('input', this.checked);
			this.$emit('change', {
				value: this.checkboxValue,
				checked: this.checked
			});
		}
	}
};
